.container {
  padding: 1.6rem;
}

.description {
  line-height: 2.4rem;
  color: var(--color-texts-low-contrast);
  overflow-wrap: break-word;
  margin-bottom: 2.4rem;
}

.download-images-container {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  margin-bottom: 1.6rem;

  @media (min-width: $bp-medium) {
    flex-direction: row;
  }
}

.company-icon-wrapper {
  & > div {
    border: unset;

    & > div {
      background: unset;
      padding: unset;
    }

    & > div:last-child,
    [data-photo-uploader] {
      width: 21.7rem;
      height: 21.7rem;
    }

    img {
      object-fit: cover;
    }
  }
}

.company-logo-wrapper {
  width: 100%;

  & > div {
    border: unset;

    & > div {
      background: unset;
      padding: unset;
    }

    & div[data-theme],
    [data-photo-uploader] {
      height: 24.2rem;
      max-width: 43rem;
      border-radius: var(--border-radius-medium);

      @media (min-width: $bp-medium) {
        height: 21.7rem;
        width: 38.8rem;
      }
    }
  }
}

.button-group-container {
  display: none;
  flex-direction: row;
  justify-content: end;
  border-top: 1px solid #31343c;
  padding: 2rem 0;

  @media screen and (min-width: $bp-medium) {
    display: flex;
  }
}

.field-container {
  margin-bottom: 1.6rem;

  span {
    min-height: unset;
    margin-bottom: unset;
  }
}

.form {
  width: 100%;
  max-width: 64.8rem;
}
